"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOperationExtraRaw = exports.fromOperationExtraRaw = void 0;
const bignumber_js_1 = require("bignumber.js");
function fromOperationExtraRaw(extraRaw) {
    const extra = {};
    if (extraRaw.frozenAmount) {
        extra.frozenAmount = new bignumber_js_1.BigNumber(extraRaw.frozenAmount);
    }
    if (extraRaw.unfreezeAmount) {
        extra.unfreezeAmount = new bignumber_js_1.BigNumber(extraRaw.unfreezeAmount);
    }
    if (extraRaw.votes) {
        extra.votes = extraRaw.votes;
    }
    return extra;
}
exports.fromOperationExtraRaw = fromOperationExtraRaw;
function toOperationExtraRaw(extra) {
    const extraRaw = {};
    if (extra.frozenAmount) {
        extraRaw.frozenAmount = extra.frozenAmount.toString();
    }
    if (extra.unfreezeAmount) {
        extraRaw.unfreezeAmount = extra.unfreezeAmount.toString();
    }
    if (extra.votes) {
        extraRaw.votes = extra.votes;
    }
    return extraRaw;
}
exports.toOperationExtraRaw = toOperationExtraRaw;
exports.default = {
    fromOperationExtraRaw,
    toOperationExtraRaw,
};
//# sourceMappingURL=account.js.map